import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"height":"calc(100vh - 3.5rem)","scrollbar-width":"thin"},
  class: "mt-14 grid grid-cols-1 gap-y-2 md:grid-cols-10 md:gap-x-1 md:gap-y-0 lg:gap-x-1 column w-full h-full bg-[#3a414a] vScore overflow-y-auto"
}
const _hoisted_2 = {
  style: {"display":"flex","flex-direction":"column","scrollbar-width":"thin"},
  class: "col-span-3 md:mt-0 mt-2"
}
const _hoisted_3 = {
  key: 0,
  class: "flex justify-between items-center px-2 text-slate-200 2xl:text-base text-sm min-h-min bg-[#1f2937] rounded-[5px] border-2 border-[#1f2937] border-solid mb-1 h-min"
}
const _hoisted_4 = { class: "flex items-center my-2" }
const _hoisted_5 = { class: "bg-[#dcdde0] text-black font-medium rounded-lg py-0.25 px-3 mx-1 w-max h-min" }
const _hoisted_6 = { class: "min-h-min bg-[#1f2937] rounded-t-[5px] border-2 border-[#1f2937] border-solid text-[#dcdde0] pt-3 relative" }
const _hoisted_7 = { class: "absolute left-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col justify-around text-center font-bold"
}
const _hoisted_9 = {
  key: 0,
  class: "float-center text-2xl 2xl:text-4xl"
}
const _hoisted_10 = { class: "font-thin italic text-base" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-row justify-evenly p-1 min-width-min px-14"
}
const _hoisted_12 = { class: "list-none text-sm font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString("Innings") + ": ", -1)
const _hoisted_14 = { class: "text-green-500 mr-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString(" Over") + ": ", -1)
const _hoisted_16 = { class: "text-green-500 mr-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString(" Ball") + ": ", -1)
const _hoisted_18 = { class: "text-green-500 mr-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString(" Delivery") + ": ", -1)
const _hoisted_20 = { class: "text-green-500 mr-2" }
const _hoisted_21 = {
  key: 2,
  class: "flex justify-around mt-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 2xl:text-sm text-xs font-extrabold" }, "Batting", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center",
  style: {"position":"absolute"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 2xl:text-sm text-xs font-extrabold" }, "Bowling", -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  class: "flex justify-around mt-3"
}
const _hoisted_27 = { class: "ml-1 2xl:text-sm text-xs font-extrabold" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sort-alt text-md text-[#dcdde0]" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "ml-1 2xl:text-sm text-xs font-extrabold" }
const _hoisted_31 = {
  key: 1,
  class: "flex flex-row md:flex-col xl:flex-row min-h-min bg-[#1f2937] pt-1 text-[#dcdde0]"
}
const _hoisted_32 = {
  key: 0,
  class: "w-full h-full flex flex-col p-1 px-2 live mb-1"
}
const _hoisted_33 = { class: "flex flex-row" }
const _hoisted_34 = { class: "w-full" }
const _hoisted_35 = { class: "flex justify-center pb-1 my-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sort-alt text-md text-[#dcdde0]" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "w-full" }
const _hoisted_40 = {
  key: 1,
  class: "w-full h-full flex flex-col p-1 px-2 live mb-1"
}
const _hoisted_41 = { class: "flex flex-row" }
const _hoisted_42 = { class: "w-full" }
const _hoisted_43 = { class: "flex justify-center pb-1 my-1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sort-alt text-md text-[#dcdde0]" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "flex flex-row" }
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = { class: "w-full flex flex-col live h-auto" }
const _hoisted_49 = { class: "h-min w-full mr-0.5 flex justify-center flex-col items-center min-w-min pt-2 bg-[#1f2937] rounded-b-[5px] pb-2" }
const _hoisted_50 = {
  key: 0,
  class: "text-center text-[#dcdde0] mt-[-0.25rem] min-w-9 content-center uppercase text-sm"
}
const _hoisted_51 = {
  key: 1,
  class: "flex flex-row pt-0.5 h-full ml-0.5"
}
const _hoisted_52 = {
  key: 2,
  class: "flex justify-center flex-row items-center pt-0.5 ml-auto mr-2 h-full"
}
const _hoisted_53 = {
  key: 3,
  class: "flex justify-center flex-row items-center pt-0.5 ml-auto mr-2 h-full"
}
const _hoisted_54 = {
  key: 4,
  class: "flex justify-center flex-row items-center pt-0.5 ml-auto mr-2 h-full"
}
const _hoisted_55 = {
  key: 0,
  class: "live flex flex-col-reverse gap-y-1 h-full overflow-y-hidden 2xl:text-base xl:text-sm text-xs bg-[#1f2937] text-[#dcdde0]",
  style: {"scrollbar-width":"thin"}
}
const _hoisted_56 = {
  class: "h-full bg-[#1f2937] rounded-t-[5px] border-2 border-[#1f2937] border-solid pt-4 pb-0 text-[#dcdde0]",
  style: {"height":"inherit"}
}
const _hoisted_57 = {
  class: "h-full",
  style: {"display":"grid","grid-template-rows":"1fr auto"}
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "live content-center items-center justify-between relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-5/6" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs p-0.5 pb-0 pl-0 float-left" }, "WAGONWHEEL"),
    /*#__PURE__*/_createElementVNode("div", {
      id: "WagonDot",
      class: "w-full flex justify-center pr-2 h-full"
    })
  ])
], -1)
const _hoisted_59 = {
  class: "flex flex-row",
  style: {"display":"flex","margin-top":"auto"}
}
const _hoisted_60 = { class: "grid-cols-2 w-full flex justify-between items-center h-min text-black" }
const _hoisted_61 = {
  class: "flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded",
  style: {"background-color":"aliceblue"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"aliceblue"},
  class: "rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: {"font-size":"xxx-large","color":"deeppink"}
  })
], -1)
const _hoisted_63 = { class: "font-bold text-2xl block mb-2 mt-2" }
const _hoisted_64 = { class: "mb-0" }
const _hoisted_65 = { class: "flex items-center gap-2 mt-6" }
const _hoisted_66 = {
  class: "flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded",
  style: {"background-color":"white"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"white"},
  class: "rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: {"font-size":"xxx-large","color":"deeppink"}
  })
], -1)
const _hoisted_68 = { class: "font-bold text-2xl block mb-2 mt-2" }
const _hoisted_69 = { class: "mb-4" }
const _hoisted_70 = { class: "flex items-center gap-2 mt-7" }
const _hoisted_71 = {
  class: "flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded",
  style: {"background-color":"white"}
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background-color":"white"},
  class: "rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: {"font-size":"xxx-large","color":"deeppink"}
  })
], -1)
const _hoisted_73 = { class: "font-bold text-2xl block mb-2 mt-2" }
const _hoisted_74 = { class: "mb-2" }
const _hoisted_75 = { class: "card flex justify-content-center mb-2" }
const _hoisted_76 = { class: "block" }
const _hoisted_77 = { class: "text-lg font-semibold" }
const _hoisted_78 = { class: "text-xs" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars content-center" }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-2 text-base" }, "Other")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center w-full px-2" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-full border-s-2 solid border-gray-400" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl px-3 font-semibold text-gray-500" }, "OR"),
  /*#__PURE__*/_createElementVNode("hr", { class: "w-full border-s-2 solid border-gray-400" })
], -1)
const _hoisted_81 = { class: "flex w-full justify-around" }
const _hoisted_82 = { class: "w-1/2 flex justify-center" }
const _hoisted_83 = { class: "block" }
const _hoisted_84 = { class: "text-lg font-semibold" }
const _hoisted_85 = { class: "text-xs" }
const _hoisted_86 = { class: "w-1/2 flex justify-center" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center w-full px-2" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-full border-s-2 solid border-gray-400" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl px-3 font-semibold text-gray-500" }, "OR"),
  /*#__PURE__*/_createElementVNode("hr", { class: "w-full border-s-2 solid border-gray-400" })
], -1)
const _hoisted_88 = { class: "flex items-center gap-2 mt-6" }
const _hoisted_89 = {
  key: 1,
  class: "h-1/2"
}
const _hoisted_90 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","justify-content":"space-between"},
  class: "text-[#dcdde0] h-full"
}
const _hoisted_91 = {
  class: "h-full w-full p-2",
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}, " Extras", -1)
const _hoisted_93 = { style: {"font-size":"xx-large"} }
const _hoisted_94 = {
  key: 0,
  class: "h-full w-full p-2",
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}, " Partnership", -1)
const _hoisted_96 = {
  class: "h-full w-full content-center justify-center",
  style: {"flex-direction":"column","align-items":"center","align-self":"center","display":"flex"}
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", null, " Runs ", -1)
const _hoisted_98 = { style: {"font-size":"xx-large"} }
const _hoisted_99 = {
  class: "h-full w-full content-center justify-center",
  style: {"flex-direction":"column","align-items":"center","align-self":"center","display":"flex"}
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", null, " Balls ", -1)
const _hoisted_101 = { style: {"font-size":"xx-large"} }
const _hoisted_102 = {
  class: "h-full w-full content-center justify-center",
  style: {"flex-direction":"column","align-items":"center","align-self":"center","display":"flex"}
}
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"x-small"} }, " Runs / Balls ", -1)
const _hoisted_105 = { style: {"font-size":"xx-large"} }
const _hoisted_106 = {
  class: "h-full w-full content-center justify-center",
  style: {"flex-direction":"column","align-items":"center","align-self":"center","display":"flex"}
}
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"x-small"} }, " Runs / Balls ", -1)
const _hoisted_109 = { style: {"font-size":"xx-large"} }
const _hoisted_110 = {
  class: "h-full w-full p-2",
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}, " Reviews left", -1)
const _hoisted_112 = { class: "h-full w-full content-center" }
const _hoisted_113 = { class: "text-center" }
const _hoisted_114 = {
  key: 0,
  style: {"font-size":"xx-large"},
  class: "text-center"
}
const _hoisted_115 = {
  key: 1,
  style: {"font-size":"xx-large"},
  class: "text-center"
}
const _hoisted_116 = { class: "h-full w-full content-center" }
const _hoisted_117 = { class: "text-center" }
const _hoisted_118 = {
  key: 0,
  style: {"font-size":"xx-large"},
  class: "text-center"
}
const _hoisted_119 = {
  key: 1,
  style: {"font-size":"xx-large"},
  class: "text-center"
}
const _hoisted_120 = {
  key: 0,
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}
const _hoisted_121 = { class: "h-full w-full content-center" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-nowrap px-4" }, "Target Score", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-nowrap px-4" }, "Target Overs", -1)
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = {
  style: {"font-size":"xx-large"},
  class: "text-center content-center justify-center w-full mr-1"
}
const _hoisted_126 = { class: "text-3xl" }
const _hoisted_127 = {
  style: {"font-size":"xx-large"},
  class: "text-center content-center justify-center w-full"
}
const _hoisted_128 = { class: "text-3xl" }
const _hoisted_129 = { class: "w-full justify-center flex" }
const _hoisted_130 = {
  key: 0,
  class: "live flex flex-col gap-y-1 h-full overflow-y-hidden 2xl:text-base xl:text-sm text-xs bg-[#1f2937] text-[#dcdde0]",
  style: {"scrollbar-width":"thin"}
}
const _hoisted_131 = { class: "h-full flex flex-col" }
const _hoisted_132 = { class: "flex flex-row pt 2 mb-2" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "RUNS/EXTRAS", -1)
const _hoisted_134 = { class: "flex flex-col h-full w-full" }
const _hoisted_135 = { class: "flex h-full w-full pb-1" }
const _hoisted_136 = { class: "grid gap-[0.1rem] grid-cols-7 w-full h-full" }
const _hoisted_137 = { class: "h-[100%] mr-0.5 flex flex-col w-1/5 justify-end runs pl-2" }
const _hoisted_138 = { class: "flex h-full pt-1" }
const _hoisted_139 = { class: "grid gap-[0.1rem] grid-cols-8 w-full" }
const _hoisted_140 = { class: "runs w-full rounded-lg h-full" }
const _hoisted_141 = { class: "flex flex-col gap-4 w-[16rem]" }
const _hoisted_142 = {
  for: "minmax",
  class: "font-bold block mb-2"
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1)
const _hoisted_145 = { class: "h-[100%] mr-0.5 flex flex-col leading-snug justify-end" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("span", { class: "text-center text-[#dcdde0] min-w-9 px-2 w-full text-xs content-center uppercase" }, " Boundary ", -1)
const _hoisted_147 = { class: "grid gap-[0.1rem] grid-cols-2 w-full pl-1" }
const _hoisted_148 = {
  key: 0,
  class: "flex h-full w-full flex-col text-black"
}
const _hoisted_149 = { class: "rounded-lg h-full flex items-end" }
const _hoisted_150 = { class: "text-center" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Batsman", -1)
const _hoisted_152 = { class: "text-center" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Bowler", -1)
const _hoisted_154 = { class: "text-center" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Fielder", -1)
const _hoisted_156 = { class: "flex items-center text-end mr-2" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-min max-w-fit" }, "Bowler Credit", -1)
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "flex flex-row h-[15%] pb-1" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "SHOT INTENTION", -1)
const _hoisted_161 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_162 = { class: "flex flex-row h-[15%] mb-1" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "BATTING", -1)
const _hoisted_164 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_165 = { class: "flex flex-row h-[15%] mb-1" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "BOWLING", -1)
const _hoisted_167 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_168 = { class: "flex flex-row h-[6%] mb-1" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "FIELDING", -1)
const _hoisted_170 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_171 = { class: "flex flex-row h-[6%] mb-1" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "EVENT", -1)
const _hoisted_173 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_174 = { class: "flex flex-row h-[10%] mb-1" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("p", { class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]" }, "BREAKS", -1)
const _hoisted_176 = { class: "grid gap-[0.1rem] grid-cols-5 w-full" }
const _hoisted_177 = {
  class: "flex flex-row",
  style: {"display":"flex","margin-top":"auto"}
}
const _hoisted_178 = { class: "grid-cols-2 w-full flex justify-end items-center h-min text-black" }
const _hoisted_179 = { class: "flex flex-col justify-between h-full bg-[#1f2937]" }
const _hoisted_180 = { class: "flex flex-row h-[3%] mb-1 live" }
const _hoisted_181 = { class: "grid gap-[0.1rem] grid-cols-6 w-full" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_183 = {
  key: 0,
  class: "h-full",
  style: {"height":"90%"}
}
const _hoisted_184 = { class: "flex items-center gap-2" }
const _hoisted_185 = { class: "flex items-center gap-2" }
const _hoisted_186 = { key: 0 }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check text-xs" }, null, -1)
const _hoisted_188 = [
  _hoisted_187
]
const _hoisted_189 = { key: 0 }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check text-xs" }, null, -1)
const _hoisted_191 = [
  _hoisted_190
]
const _hoisted_192 = { key: 0 }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check text-xs" }, null, -1)
const _hoisted_194 = [
  _hoisted_193
]
const _hoisted_195 = ["disabled"]
const _hoisted_196 = { class: "flex flex-row justify-evenly p-1 min-width-min px-14" }
const _hoisted_197 = { class: "list-none text-sm font-bold" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString("Innings") + ": ", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString("Over") + ": ", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString("Ball") + ": ", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wide font-medium" }, /*#__PURE__*/_toDisplayString("Delivery") + ": ", -1)
const _hoisted_202 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_203 = {
  class: "h-full w-full p-2",
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_204 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}, " Team", -1)
const _hoisted_205 = { class: "flex w-full mb-1.5" }
const _hoisted_206 = { class: "card flex wrap-none justify-center m-auto w-2/3 max-w-min" }
const _hoisted_207 = { class: "w-full font-semi px-2 m-1 flex text-center mt-1 justify-center" }
const _hoisted_208 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_209 = { class: "text-center" }
const _hoisted_210 = {
  class: "h-full w-full p-2",
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_211 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-center min-w-9 content-center mr-0.5 ml-[-0.23rem]",
  style: {"writing-mode":"vertical-rl","transform":"scale(-1)","text-transform":"uppercase"}
}, " Result", -1)
const _hoisted_212 = { class: "flex w-full mb-1.5" }
const _hoisted_213 = { class: "card flex wrap-none justify-center m-auto w-2/3 max-w-min" }
const _hoisted_214 = { class: "w-full font-semi px-2 m-1 flex text-center mt-1 justify-center" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex w-full justify-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Manual Innings Override")
], -1)
const _hoisted_216 = { class: "flex justify-between mt-4" }
const _hoisted_217 = { class: "flex flex-col items-center mx-2" }
const _hoisted_218 = /*#__PURE__*/_createElementVNode("label", null, "Inning", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1)
const _hoisted_221 = { class: "flex flex-col items-center mx-2" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("label", null, "Over", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1)
const _hoisted_225 = { class: "flex flex-col items-center mx-2" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("label", null, "Ball", -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1)
const _hoisted_229 = { class: "flex flex-col items-center mx-2" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("label", null, "Delivery", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-minus" }, null, -1)

import { computed, ref, Ref, watch, onMounted, onUnmounted, onBeforeMount } from 'vue'
import DataTabs from '../components/DataTabs.vue'
import Table from '../components/DataTable.vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';
import Dropdown from 'primevue/dropdown';
import 'primeicons/primeicons.css'
import SelectButton from 'primevue/selectbutton';
import Button from 'primevue/button';
import { initialiseViewer, disposeViewer } from "../../BuiltFilesForNodedDEV/cricket-arcs";
import { useConfirm } from "primevue/useconfirm";
import { querystate } from "../store/vscore/index"
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import Checkbox from 'primevue/checkbox';
import ConfirmDialog from 'primevue/confirmdialog';
import * as v from '@/models/vscoreModels'
import InputNumber from 'primevue/inputnumber';
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import ToggleButton from 'primevue/togglebutton';
import Inplace from 'primevue/inplace';
import Badge from 'primevue/badge';

import { useRouter, useRoute } from 'vue-router'
enum Dismissal {
    '-' = 0,
    Caught = 1,
    Bowled = 2,
    LBW = 3,
    RunOut = 4,
    Stumped = 5,
    TimedOut = 6,
    HandledBall = 7,
    ObstructingField = 8,
    HitWicket = 9,
    HitBallTwice = 10,
    Retired = 11,
    ManKad = 12
}

enum DeliveryType {
    Unset = 0,
    Stock = 1,
    InSwing = 2,
    OutSwing = 3,
    ReverseSwing = 4,
    SeamUp = 5,
    CrossSeam = 6,
    SlowerBall = 7,
    KnuckleBall = 8,
    FullToss = 9,
    Beamer = 10,
    Cutter = 11,
    WrongunDoosra = 12,
    TopSpinner = 13,
    ArmBall = 14,
    Slider = 15,
    CarromBall = 16
}

enum ShotIntention {
    Attacked = 1,
    Defended = 2,
    LeftAlone = 3
}

enum ShotSelection {
    Drive = 1,
    Pull = 2,
    Hook = 3,
    Cut = 4,
    Block = 5,
    Leave = 6,
    Sweep = 7,
    ReverseSweep = 8,
    Ramp = 9,
    Scoop = 10,
    Dab = 11,
    Glance = 12
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DataCollectorView',
  setup(__props) {

const visible = ref(false);
const newInnings = ref(false);
let disabledSubmit = ref(false);
let dlsActive = ref(false);
const onLocal = ref(true)

const toast = useToast();
const stateStore = querystate();
stateStore.$reset()
let isLoading = ref(true)

let manualoverride = ref({
    manualinnings: 1,
    manualover: 0,
    manualball: 1,
    manualdelivery: 1
})
let teamoptions = ref([]);
let reviewObject = ref({
    selectedTeam: null,
    result: null,
    innings: 0,
    over: 0,
    delivery: 0,
    ball: 0
})
const teamHasBeenSelected = ref(false)
const matchResultValue = ref({ value: "" })
const teamSelectedResult = ref({ value: "" })

const confirm = useConfirm();
let editIndex: string | number | undefined;
let editObject;
let prevStateObject;
const editMode = ref(false);

window.onkeyup = function (e) {
    if (e.key == "`") {
        state.value.currentPlayState.delivery.runs += 1
        //alert("One Run Sent To Increment");
        stateStore.runSendToIOT({ tick: 1 })
    }
};
const op = ref();
const toggle = (event: any) => {
    op.value.toggle(event);
}

function manualOverrideTriggered() {
    state.value.currentPlayState.delivery.innings = manualoverride.value.manualinnings
    state.value.currentPlayState.delivery.over = manualoverride.value.manualover
    state.value.currentPlayState.delivery.number = manualoverride.value.manualdelivery
    state.value.currentPlayState.delivery.ball = manualoverride.value.manualball
    showSuccess('Manual Override', 'Play Init event sent for the overrided play');
    stateStore.startPlay()
    newInnings.value = false
}

const onRowSelect = (event: { index: any; }) => {
    if (!editMode.value) {
        editIndex = event.index
    }
};

const rowStyle = (data: any) => {
    if (state.value.currentPlayState.selectedBall != null && state.value.currentPlayState.selectedBall == data && editMode.value == true) {
        return { background: '#C3D4E1' };
    }
    else if (state.value.currentPlayState.selectedBall != null && state.value.currentPlayState.selectedBall == data && editMode.value == false) {
        return { background: '#E3F2FD' };
    }
};

function showSuccess(title: string, message: string) {
    toast.add({
        severity: 'success', summary: title, detail: message, life: 3000
    })
}

function showError(title: string, message: string) {
    toast.add({
        severity: 'error', summary: title, detail: message, life: 3000
    })
}

function showEvent(title: string) {
    confirm.require({
        group: 'positioned',
        message: 'Are you sure you want to proceed?',
        header: title,
        icon: 'pi pi-info-circle',
        position: 'bottomright',
        rejectLabel: 'Cancel',
        acceptLabel: 'Save',

        accept: () => {
            toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Request submitted', life: 3000 });
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Process incomplete', life: 3000 });
        }
    });
}

async function confirmNewOver() {
    if ((state.value.currentPlayState.selectedBatt1 && state.value.currentPlayState.selectedBatt2 && state.value.currentPlayState.selectedBowler1 && state.value.currentPlayState.selectedBowler2) != null) {
        showSuccess('Play Event', 'Play Init event sent');
        state.value.currentPlayState.isblurred = false;
        stateStore.startPlay()
        await stateStore.getMatchById(state.value.MatchInfo.id)
    } else if ((state.value.currentPlayState.selectedBatt1 && state.value.currentPlayState.selectedBatt2 != null) && ((state.value.currentPlayState.isSelectedBowl1 == true && state.value.currentPlayState.selectedBowler1 != null) || (state.value.currentPlayState.isSelectedBowl1 == false && state.value.currentPlayState.selectedBowler2 != null))) {
        showSuccess('Play Event', 'Play Init event sent');
        state.value.currentPlayState.isblurred = false;
        stateStore.startPlay()
        await stateStore.getMatchById(state.value.MatchInfo.id)
    }
    else if ((state.value.currentPlayState.selectedBatt1 && state.value.currentPlayState.selectedBatt2 != null) && ((state.value.currentPlayState.isSelectedBowl1 == true && state.value.currentPlayState.selectedBowler1 == null) || (state.value.currentPlayState.isSelectedBowl1 == false && state.value.currentPlayState.selectedBowler2 == null))) {
        showError('Error', 'Bowler has not been selected')
    }
    else {
        showError('Error', 'Batters & Bowlers have not been selected')
    }
}

async function confirmUpdatePlayers() {
    showSuccess('Players Update', 'Player update event sent');
    /// inings number over delivery 
    if (state.value.currentPlayState.delivery.boundary == null) {
        state.value.currentPlayState.delivery.boundary = 0;
    }
    stateStore.updateDeliveryPlayers()
    await stateStore.getMatchById(state.value.MatchInfo.id)
}

async function editSelectedBall() {
    editMode.value = true

    state.value.currentPlayState.delivery = Object.assign({}, await state.value.InningsData[state.value.currentPlayState.inningsIndex].previousDeliveries[editIndex])
    if(state.value.currentPlayState.delivery.wides! > 0){
        state.value.currentPlayState.delivery.runs = state.value.currentPlayState.delivery.wides!-1
        state.value.currentPlayState.delivery.wides = 1
    }
    state.value.currentPlayState.selectedBatt1 = state.value.MatchInfo.team1.players.find(u => u.player.id === state.value.currentPlayState.delivery.nonStriker.id)
    state.value.currentPlayState.selectedBatt2 = state.value.MatchInfo.team1.players.find(u => u.player.id === state.value.currentPlayState.delivery.striker.id)
    state.value.currentPlayState.selectedBowler2 = state.value.MatchInfo.team2.players.find(u => u.player.id === state.value.currentPlayState.delivery.bowler.id)
    state.value.currentPlayState.isSelectedBatt1 = false
    if (state.value.currentPlayState.selectedBatt1 == undefined) {
        state.value.currentPlayState.selectedBatt1 = state.value.MatchInfo.team2.players.find(u => u.player.id === state.value.currentPlayState.delivery.nonStriker.id)
        state.value.currentPlayState.selectedBatt2 = state.value.MatchInfo.team2.players.find(u => u.player.id === state.value.currentPlayState.delivery.striker.id)
        state.value.currentPlayState.selectedBowler2 = state.value.MatchInfo.team1.players.find(u => u.player.id === state.value.currentPlayState.delivery.bowler.id)
        state.value.currentPlayState.isSelectedBatt1 = false
    }
}

async function abortEdit() {
    editMode.value = false
    state.value.currentPlayState.selectedBall = null
    // stateStore.resetCurrentPlayState(prevStateObject)
    await stateStore.getMatchById(state.value.MatchInfo.id)
}
function swapTeams() {
    let tempstore = state.value.BattingTeam;
    stateStore.setBattingTeam(state.value.BowlingTeam)
    stateStore.setBowlingTeam(tempstore);
    state.value.currentPlayState.selectedBowler1 = null
    state.value.currentPlayState.selectedBowler2 = null
    state.value.currentPlayState.selectedBatt1 = null
    state.value.currentPlayState.selectedBatt2 = null
    state.value.currentPlayState.selectedBowler1data = [{}]
    state.value.currentPlayState.selectedBowler2data = [{}]
    state.value.currentPlayState.selectedBatt1data = [{}]
    state.value.currentPlayState.selectedBatt2data = [{}]
    state.value.currentPlayState.isblurred = true
}

const requireConfirmationOver = () => {
    confirm.require({
        group: 'headless',
        header: 'Finish The Over?',
        message: 'Please confirm to proceed.',
        accept: () => {
            state.value.currentPlayState.isblurred = true;
            state.value.currentPlayState.isSelectedBatt1 = !state.value.currentPlayState.isSelectedBatt1
            state.value.currentPlayState.isSelectedBowl1 = !state.value.currentPlayState.isSelectedBowl1
            if (state.value.currentPlayState.delivery.bowlingEnd == v.BowlingEndEnum.NORTH) {
                state.value.currentPlayState.delivery.bowlingEnd = v.BowlingEndEnum.SOUTH
            } else {
                state.value.currentPlayState.delivery.bowlingEnd = v.BowlingEndEnum.NORTH
            }
            state.value.currentPlayState.delivery.over += 1
            state.value.currentPlayState.delivery.ball = 1
            state.value.currentPlayState.delivery.number = 1
        },
        reject: () => {
            console.log("Deny Over")
        }
    });
};
let isDeclare = ref(false)

const requireConfirmationInnings = () => {
    isDeclare.value = false
    confirm.require({
        group: 'headless2',
        header: 'Finish The Innings?',
        message: 'Please confirm to proceed.',
        accept: () => {
            state.value.currentPlayState.isblurred = true;
            if (isDeclare.value) {
                stateStore.declareInnings({ innings: state.value.currentPlayState.delivery.innings, declared: true })
            }
            state.value.InningsData.push({})
            state.value.currentPlayState.selectedBatt1data = [{}]
            state.value.currentPlayState.selectedBatt2data = [{}]
            state.value.currentPlayState.selectedBowler2data = [{}]
            state.value.currentPlayState.delivery.over = 0
            state.value.currentPlayState.delivery.ball = 1
            state.value.currentPlayState.delivery.number = 1
            state.value.currentPlayState.delivery.innings += 1
            state.value.currentPlayState.inningsIndex += 1
            swapTeams();
        },
        reject: () => {
            console.log("Deny Innings")
        }
    });
};

const requireConfirmationMatch = () => {
    isDeclare.value = false
    confirm.require({
        group: 'headlessMatch',
        header: 'Finish The Match?',
        message: 'Please confirm to proceed.',
        accept: () => {
            state.value.currentPlayState.isblurred = true;
            console.log("Match ended: " + matchResultValue.value.value)
            matchResultValue.value.value = ""
            teamSelectedResult.value.value = ""
        },
        reject: () => {
            console.log("Deny Match Ending")
            matchResultValue.value.value = ""
            teamSelectedResult.value.value = ""
        }
    });
};


const smallScreen = ref(false)
const scoringHeaders = ["Live Scoring"] //, "TT", "Auto Scoring"
const cardHeaders = ["Ball By Ball"] //, "Batting Card", "Bowling Card"
const cardHeadersShort = ["Balls"] //, "Batts", "Bowls"
const wagonWheel = ["Wagon Wheel", "Statistics"]

const state = ref({
    currentPlayState: computed(() => {
        return stateStore.getCurrentPlayState;
    }),
    InningsData: computed(() => {
        return stateStore.getInningsData;
    }),
    BattingTeam: computed(() => {
        return stateStore.getBattingTeam;
    }),
    BowlingTeam: computed(() => {
        return stateStore.getBowlingTeam;
    }),
    MatchInfo: computed(() => {
        return stateStore.getMatchInfo;
    }),
});

const ballByBallColumns = [
    { name: "INN", key: "innings" },
    { name: "OVR", key: "over" },
    { name: "BALL", key: "ball" },
    { name: "DLIV", key: "number" },
    { name: "END", key: "bowlingEnd" },
    { name: "RUN", key: "runs" },
    { name: "NB", key: "noballs" },
    { name: "W", key: "wides" },
    { name: "B", key: "byes" },
    { name: "LB", key: "legbyes" },
    { name: "BNDRY", key: "boundary" },
    { name: "STKR", key: "striker.name" },
    { name: "NSTKR", key: "nonStriker.name" },
    { name: "BWL", key: "bowler.name" },
]

const ballByBallData: Ref<[]> = ref([])

// Leftside panel Data

const scoreOneColumns = [{ name: "RUNS", key: "runs" }, { name: "BALLS", key: "balls" }, { name: "4s", key: "fours" }, { name: "6s", key: "sixes" }, { name: "RATE", key: "strikeRate" }]
const scoreTwoColumns = [{ name: "OVR", key: "overs" }, { name: "MDNS", key: "maidens" }, { name: "WKT", key: "dismissalAmount" }, { name: "RUNS", key: "runs" }, { name: "BALLS", key: "balls" }]
const scoreOneData = [{ runs: 57, balls: 33, fours: 4, sixs: 1, strikeRate: 121 }]

const runItems = ref(["0", "1", "2", "3", "4", "5", "6"])
const boundary = ref(["4", "6"])
const bowlingEnd = ref([v.BowlingEndEnum.NORTH, v.BowlingEndEnum.SOUTH])
// const extraLabelsItems = ref(["Runs", "Leg Byes", "Byes", "Pen For", "Pen Against"])
const extraLabelsItems = ref(["Runs", "Leg Byes", "Byes", "Pen For", "Pen Against"])
const extrasButtons = ref(["No Balls", "Wides"])

const shotIntention = [
    "Drive", "Pull", "Hook", "Cut", "Glance", "Block", "Sweep", "Reverse Sweep", "Slog Sweep", "Ramp", "Leave", "Switch Hit", "Scoop", "Lap", "Padded Away"
]
const bowling = [
    "In Swing", "Out Swing", "Reverse Swing", "Seam Up", "Cross Seam", "Cutter", "Slower Ball", "Knuckle Ball", "Wrong'un/ Doosra", "Googly", "Top Spinner", "Arm Ball", "Carrom Ball", "Slider", "Stock"
]
const batting = [
    "Front Foot", "Back Foot", "In The Air", "Along The Ground", "Used Feet", "Miss Hit", "Play And Miss", "Inside Edge", "Outside Edge", "Top Edge", "Evasive Action", "Slog"
]
const event = [
    "Drs Challenge", "Umpire Review", "Lbw Appeal", "Other Appeal", "New Ball Taken"
]
const fielding = [
    "Run Out Chance", "Stumping Chance", "Miss Field", "Drop Catch", "Over Throws"
]
const breaksInPlay = [
    "DRINKS_BREAK", "LUNCH_BREAK", "TEA_BREAK", "END_OF_DAY_BREAK", "INJURY_BREAK", "RAIN_BREAK", "BAD_LIGHT_BREAK"
]

const dismissal = [
    { name: 'Caught', code: v.DismissalCodeEnum.CAUGHT },
    { name: 'Bowled', code: v.DismissalCodeEnum.BOWLED },
    { name: 'LBW', code: v.DismissalCodeEnum.LBW },
    { name: 'Stumped', code: v.DismissalCodeEnum.STUMPED },
    { name: 'Run Out', code: v.DismissalCodeEnum.RUNOUT },
    { name: 'Hit Wicket', code: v.DismissalCodeEnum.HITWICKET },
    { name: 'Handled Ball', code: v.DismissalCodeEnum.HANDLEDBALL },
    { name: 'Hit Ball Twice', code: v.DismissalCodeEnum.HITTWICE },
    { name: 'Obstructing Field', code: v.DismissalCodeEnum.OBSTRUCTINGTHEFIELD },
    { name: 'Timed Out', code: v.DismissalCodeEnum.TIMEDOUT },
    { name: 'Retired', code: v.DismissalCodeEnum.RETIRED },
    { name: 'Retired Hurt', code: v.DismissalCodeEnum.RETIREDHURT },
]
const router = useRouter()
const route = useRoute()
onMounted(async () => {
    await stateStore.getMatchById(`${route.query.q}`)
    isLoading.value = false
    window.addEventListener("resize", setSmallScreen);
    setSmallScreen()
    initialiseViewer(document.getElementById("WagonDot"));// attach 
    teamoptions = [state.value.BattingTeam.team.name, 'Return']
    checkForPendingReviews()
})

onUnmounted(async () => {
    window.removeEventListener('resize', setSmallScreen)
    disposeViewer();
})

function toggleClass(component: any, item: any, source: any) {
    switch (source) {
        case 'batting':
            setMultiValue('battingSelection', item);
            break;
        case 'fielding':
            setMultiValue('fieldingSelection', item);
            break;
        case 'breaks':
            // setMultiValue('breakSelection', item);
            setBreaks(item);
            break;
        case 'extras':
            setSingleValueExtra('extras', item);
            break;
        case 'runSelect':
            setRunsToExtra(item);
            break;
        case 'boundary':
            setSingleValue('boundary', Number.parseInt(item));
            break;
        case 'shotSelection':
            switch (item) {
                case 'Block':
                    state.value.currentPlayState.shotIntention = ShotIntention.Defended;
                    break;
                case 'Padded Away':
                    state.value.currentPlayState.shotIntention = ShotIntention.Defended;
                    break;
                case 'Leave':
                    state.value.currentPlayState.shotIntention = ShotIntention.LeftAlone;
                    break;
                default:
                    state.value.currentPlayState.shotIntention = ShotIntention.Attacked;
                    break;
            }
            if (state.value.currentPlayState.shotSelectionText == item) {
                state.value.currentPlayState.shotSelectionText = '';
            } else {
                state.value.currentPlayState.shotSelectionText = item
            }

            setSingleValue(source, component[item.replace(/[/'\s]/g, '')]);
            break;
        case 'bowlingSelection':
            if (state.value.currentPlayState.bowlSelectionText == item) {
                state.value.currentPlayState.bowlSelectionText = '';
            } else {
                state.value.currentPlayState.bowlSelectionText = item
            }
            setSingleValue(source, component[item.replace(/[/'\s]/g, '')]);
            break;
        case 'toggleExtra':
            switch (item) {
                case 'Wides':
                    if (state.value.currentPlayState.delivery.wides == 1) {
                        state.value.currentPlayState.delivery.wides = 0
                    } else {
                        state.value.currentPlayState.delivery.wides = 1
                    }
                    break;
                default:
                    if (state.value.currentPlayState.delivery.noballs == 1) {
                        state.value.currentPlayState.delivery.noballs = 0
                    } else {
                        state.value.currentPlayState.delivery.noballs = 1
                    }
                    break;
            }
            break;
        default:
            setSingleValue(source, component[item.replace(/[/'\s]/g, '')]);
            break;
    }
}

async function selectInnings(selectedInnings: { previousDeliveries: any[]; number: string | number; }) {
    selectedInnings.previousDeliveries = await stateStore.retreveInningsDeliveries(state.value.MatchInfo.id, selectedInnings.number)

    state.value.currentPlayState.inningsIndex = selectedInnings.number - 1

}

function setSingleValue(source: string, valueOf: number) {
    if (state.value.currentPlayState.delivery[`${source}`] == valueOf) {
        state.value.currentPlayState.delivery[`${source}`] = null;
    } else {
        state.value.currentPlayState.delivery[`${source}`] = valueOf;
    }
    return;
}

function setSingleValueExtra(source: string, valueOf: number) {
    state.value.currentPlayState[`${source}`] = valueOf;
    return;
}

function setRunsToExtra(item: string) {
    state.value.currentPlayState.delivery[`${state.value.currentPlayState.extras.replace(/\s+/g, '').toLowerCase()}`] = Number.parseInt(item);
}

function setMultiValue(source: string, valueOf: string) {
    if (state.value.currentPlayState[`${source}`].indexOf(valueOf) > -1) {
        state.value.currentPlayState[`${source}`].splice(state.value.currentPlayState[`${source}`].indexOf(valueOf), 1);
        if (source == "battingSelection" && (valueOf === "Lbw Appeal" ||
            valueOf === "Umpire Review" ||
            valueOf === "Drs Challenge" ||
            valueOf === "New Ball Taken")) {
            state.value.currentPlayState.event.splice(state.value.currentPlayState.event.indexOf(valueOf), 1);
        }
    } else {
        state.value.currentPlayState[`${source}`].push(valueOf)
        if (source == "battingSelection" && (valueOf === "Lbw Appeal" ||
            valueOf === "Umpire Review" ||
            valueOf === "Drs Challenge" ||
            valueOf === "New Ball Taken")) {
            state.value.currentPlayState.event.push(valueOf)
        }
    }
    return;
}

function setBreaks(item: v.BreaksEnum) {
    if (state.value.currentPlayState.delivery.breaks.indexOf(item) > -1) {
        state.value.currentPlayState.delivery.breaks.splice(state.value.currentPlayState.delivery.breaks.indexOf(item), 1)
    } else {
        state.value.currentPlayState.delivery.breaks?.push(item)
    }
}

function setSmallScreen() {
    var width = window.innerWidth
    if (width < 1041 && width > 639) {
        smallScreen.value = true
    } else {
        smallScreen.value = false
    }
}

function checkForPendingReviews() {
    // Open review dialog if active review
    if (state.value.currentPlayState.reviews) {
        state.value.currentPlayState.reviews.homeReviews.forEach((homeReview: any) => {
            if (homeReview.result == v.ReviewResultEnum.PENDING) {
                visible.value = true;
                reviewObject.value.ball = homeReview.ball
                reviewObject.value.innings = homeReview.innings
                reviewObject.value.over = homeReview.over
                reviewObject.value.delivery = homeReview.delivery
                reviewObject.value.selectedTeam = { id: homeReview.teamId, name: homeReview.teamName }
                teamHasBeenSelected.value = true
            }
        });

        state.value.currentPlayState.reviews.awayReviews.forEach((awayReview: any) => {
            if (awayReview.result == v.ReviewResultEnum.PENDING) {
                visible.value = true;
                reviewObject.value.ball = awayReview.ball
                reviewObject.value.innings = awayReview.innings
                reviewObject.value.over = awayReview.over
                reviewObject.value.delivery = awayReview.delivery
                reviewObject.value.selectedTeam = { id: awayReview.teamId, name: awayReview.teamName }
                teamHasBeenSelected.value = true
            }
        });
    }
}

function convertOptions(players: any) {
    return players.map(function (player: any) {
        return {
            id: player.player.id,
            name: player.player.name,
        }
    })
}

function getResultOptions() {
    let matchStatus = stateStore.getMatchStatus
    let options = [
        { label: "Home Win", description: matchStatus.homeTeam.name, value: v.ResultEnum.HOME_WIN },
        { label: "Away Win", description: matchStatus.awayTeam.name, value: v.ResultEnum.AWAY_WIN },
    ]
    return options
}

function getResultOptionsTeams() {
    let matchStatus = stateStore.getMatchStatus
    let options = [
        { value: "Home Team", description: matchStatus.homeTeam.name },
        { value: "Away Team", description: matchStatus.awayTeam.name },
    ]
    return options
}

function getOtherResultOptions(hasTeamSelection: boolean) {
    let options: any = Object.values(v.ResultEnum).filter((result) =>
    (result != v.ResultEnum.HOME_WIN
        && result != v.ResultEnum.AWAY_WIN
        && result != v.ResultEnum.IN_PROGRESS
        && result != v.ResultEnum.NOT_STARTED
    )
    )
    options = options.map((result: any) => {
        return { value: result }
    })
    return hasTeamSelection ? options.slice(0, 3) : options.slice(3)
}

function beginReview() {
    visible.value = true
    reviewObject.value.ball = state.value.currentPlayState.delivery.ball
    reviewObject.value.innings = state.value.currentPlayState.delivery.innings
    reviewObject.value.over = state.value.currentPlayState.delivery.over
    reviewObject.value.delivery = state.value.currentPlayState.delivery.number

}

async function pendingReview() {
    const reviewObjectParams = {
        "teamId": reviewObject.value.selectedTeam.id,
        "teamName": reviewObject.value.selectedTeam.name,
        "reviewType": "DRS",
        "result": "PENDING",
        "innings": reviewObject.value.innings,
        "over": reviewObject.value.over,
        "delivery": reviewObject.value.delivery,
        "ball": reviewObject.value.ball
    }

    reviewObjectParams["teamId"] = reviewObject.value.selectedTeam.id
    await stateStore.putReview(reviewObjectParams, editMode.value)
}

async function submitReview() {

    const reviewObjectParams = {
        "teamId": reviewObject.value.selectedTeam.id,
        "teamName": reviewObject.value.selectedTeam.name,
        "reviewType": "DRS",
        "innings": reviewObject.value.innings,
        "over": reviewObject.value.over,
        "delivery": reviewObject.value.delivery,
        "ball": reviewObject.value.ball
    }

    reviewObjectParams["result"] = reviewObject.value.result == "Lost" ? v.ReviewResultEnum.LOST : v.ReviewResultEnum.RETAINED

    // putReview
    await stateStore.putReview(reviewObjectParams, editMode.value)

    reviewObject.value.selectedTeam = null
    reviewObject.value.result = null
    reviewObject.value.ball = 0
    reviewObject.value.innings = 0
    reviewObject.value.over = 0
    reviewObject.value.delivery = 0
    teamHasBeenSelected.value = false
}

async function cancelReview() {
    reviewObject.value.selectedTeam = null
    reviewObject.value.result = null
    reviewObject.value.ball = 0
    reviewObject.value.innings = 0
    reviewObject.value.over = 0
    reviewObject.value.delivery = 0
    teamHasBeenSelected.value = false
    visible.value = false
}

async function dlsInput() {
    stateStore.adjustTargets({ targetOvers: state.value.currentPlayState.targetOvers, targetScore: state.value.currentPlayState.targetScore }, editMode.value)
}

async function saveCurrentState() {
    disabledSubmit.value = true
    //Boundary null check 
    if (state.value.currentPlayState.delivery.boundary == null) {
        state.value.currentPlayState.delivery.boundary = 0;
    }

    if (state.value.currentPlayState.delivery.wides > 0 ) {
        state.value.currentPlayState.delivery.wides += state.value.currentPlayState.delivery.runs
        state.value.currentPlayState.delivery.runs = 0
    }

    state.value.currentPlayState.delivery.isValid = (state.value.currentPlayState.delivery.noballs! > 0 || state.value.currentPlayState.delivery.wides! > 0) ? false : true
    if (editMode.value) {
        let response: any = await stateStore.updateDelivery(state.value.currentPlayState.delivery, editMode.value, <number>editIndex)
        if (response?.status == 200) {
            showSuccess('Play Update', 'Play updated')
        } else if (response?.response.status == 400) {
            showError("Error", JSON.parse(response.response.data).error.issues[0].message)
        } else {
            showError("Error", "An error occured")
        }
        state.value.currentPlayState.selectedBall = null
        editMode.value = !editMode.value
        await stateStore.getMatchById(state.value.MatchInfo.id)
    } else {
        submitAndIncrement()
    }


}

async function submitAndIncrement() {

    let response: any = await stateStore.addDelivery(state.value.currentPlayState.delivery)
    if (response?.status == 200) {
        showSuccess("Play submitted", "Play saved and submitted")
    } else if (response?.response.status == 400) {
        showError("Error", JSON.parse(response.response.data).error.issues[0].message)
    } else {
        showError("Error", "An error occured")
    }

    if (state.value.currentPlayState.delivery.noballs! > 0 || state.value.currentPlayState.delivery.wides! > 0) {
        state.value.currentPlayState.delivery.number += 1
    } else {
        state.value.currentPlayState.delivery.number += 1
        state.value.currentPlayState.delivery.ball += 1
    }
    // RUNS RULES
    if (state.value.currentPlayState.delivery.wides! > 0) {
        if ((state.value.currentPlayState.delivery.wides! - 1) % 2 != 0) {
            state.value.currentPlayState.isSelectedBatt1 = !state.value.currentPlayState.isSelectedBatt1
        }
    }
    else if (state.value.currentPlayState.delivery.noballs! > 0) {
        if ((state.value.currentPlayState.delivery.noballs! - 1) % 2 != 0) {
            state.value.currentPlayState.isSelectedBatt1 = !state.value.currentPlayState.isSelectedBatt1
        }
    }
    else {
        if ((state.value.currentPlayState.delivery.runs! + state.value.currentPlayState.delivery.legbyes! + state.value.currentPlayState.delivery.byes!) % 2 != 0) {
            state.value.currentPlayState.isSelectedBatt1 = !state.value.currentPlayState.isSelectedBatt1
        }
    }
    await stateStore.startPlay()
    await stateStore.getMatchById(state.value.MatchInfo.id)
    state.value.currentPlayState.extras = "Runs"
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (!_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(`${state.value.MatchInfo.team2.team.name} v ${state.value.MatchInfo.team1.team.name} @
                        ${state.value.MatchInfo.venue.name}`), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(state.value.MatchInfo.startDate.substring(0, 10)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Badge), {
              severity: onLocal.value ? 'success' : 'danger',
              class: "w-3 h-3 mr-1"
            }, null, 8, ["severity"])
          ]),
          (state.value.InningsData.length >= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!_unref(isLoading) && state.value.InningsData[state.value.currentPlayState.inningsIndex].battingTeam != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].battingTeam.name +
                                " "
                                + state.value.InningsData[state.value.currentPlayState.inningsIndex].score + " - "
                                + state.value.InningsData[state.value.currentPlayState.inningsIndex].wickets) + " ", 1),
                      _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].overs) + ")", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (state.value.InningsData.length >= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_unref(Button), {
                    type: "button",
                    icon: "pi pi-plus-circle",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ( newInnings.value = true))
                  }),
                  _hoisted_13,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(state.value.currentPlayState.delivery.innings), 1),
                  _hoisted_15,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(state.value.currentPlayState.delivery.over), 1),
                  _hoisted_17,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(state.value.currentPlayState.delivery.ball), 1),
                  _hoisted_19,
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(state.value.currentPlayState.delivery.number), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (state.value.currentPlayState.isblurred && (state.value.InningsData[state.value.currentPlayState.inningsIndex] == undefined || state.value.InningsData[state.value.currentPlayState.inningsIndex].battingTeam == undefined))
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_25))
            : _createCommentVNode("", true),
          (!_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(state.value.BattingTeam.team.name), 1),
                _createElementVNode("div", {
                  class: "flex justify-center",
                  style: {"position":"absolute"}
                }, [
                  _createElementVNode("button", {
                    onClick: swapTeams,
                    class: "rotate-90 hover:bg-slate-500 font-semi rounded col-span-2 w-6 h-min mb-[-0.25rem]"
                  }, _hoisted_29)
                ]),
                _createElementVNode("span", _hoisted_30, _toDisplayString(state.value.BowlingTeam.team.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (state.value.InningsData.length >= 1 && state.value.InningsData[state.value.currentPlayState.inningsIndex] != undefined && Object.keys(state.value.InningsData[state.value.currentPlayState.inningsIndex]).length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              (!_unref(isLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", {
                        class: _normalizeClass([{ selectedPerson: state.value.currentPlayState.isSelectedBatt1 }, "text-center min-w-5 content-center mr-0.1 ml-[-0.2rem] text-sm"])
                      }, "BATTER", 2),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(Dropdown), {
                          modelValue: state.value.currentPlayState.selectedBatt1,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value.currentPlayState.selectedBatt1) = $event)),
                          options: state.value.BattingTeam.players,
                          optionLabel: "player.name",
                          variant: "filled",
                          class: "h-min w-[99.3%] mb-0.5 bg-[#fcfcca]"
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(Table, {
                          data: state.value.currentPlayState.selectedBatt1data,
                          columns: scoreOneColumns,
                          class: "scoringTable min-w-min"
                        }, null, 8, ["data"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        class: "hover:bg-slate-500 font-semi rounded col-span-2 w-6 h-min mb-[-0.25rem]",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (state.value.currentPlayState.isSelectedBatt1 = !state.value.currentPlayState.isSelectedBatt1))
                      }, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("p", {
                        class: _normalizeClass([{ selectedPerson: !state.value.currentPlayState.isSelectedBatt1 }, "text-center min-w-5 content-center mr-0.1 ml-[-0.2rem] text-sm"])
                      }, "BATTER", 2),
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_unref(Dropdown), {
                          modelValue: state.value.currentPlayState.selectedBatt2,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.value.currentPlayState.selectedBatt2) = $event)),
                          options: state.value.BattingTeam.players,
                          optionLabel: "player.name",
                          variant: "filled",
                          class: "h-min w-[99.3%] mb-0.5 bg-[#fcfcca]"
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(Table, {
                          data: state.value.currentPlayState.selectedBatt2data,
                          columns: scoreOneColumns,
                          class: "scoringTable min-w-min"
                        }, null, 8, ["data"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_unref(isLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("p", {
                        class: _normalizeClass([{ selectedPerson: state.value.currentPlayState.isSelectedBowl1 }, "text-center min-w-5 content-center mr-0.1 ml-[-0.2rem] text-sm"])
                      }, "BOWLER", 2),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_unref(Dropdown), {
                          modelValue: state.value.currentPlayState.selectedBowler1,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.value.currentPlayState.selectedBowler1) = $event)),
                          options: state.value.BowlingTeam.players,
                          optionLabel: "player.name",
                          variant: "filled",
                          class: "h-min w-[99.3%] mb-0.5 bg-[#fcfcca]"
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(Table, {
                          data: state.value.currentPlayState.selectedBowler1data,
                          columns: scoreTwoColumns,
                          class: "scoringTable min-w-min"
                        }, null, 8, ["data"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("button", {
                        class: "hover:bg-slate-500 font-semi rounded col-span-2 w-6 h-min mb-[-0.25rem]",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (state.value.currentPlayState.isSelectedBowl1 = !state.value.currentPlayState.isSelectedBowl1))
                      }, _hoisted_45)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("p", {
                        class: _normalizeClass([{ selectedPerson: !state.value.currentPlayState.isSelectedBowl1 }, "text-center min-w-5 content-center mr-0.1 ml-[-0.2rem] text-sm"])
                      }, "BOWLER", 2),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_unref(Dropdown), {
                          modelValue: state.value.currentPlayState.selectedBowler2,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.value.currentPlayState.selectedBowler2) = $event)),
                          options: state.value.BowlingTeam.players,
                          optionLabel: "player.name",
                          variant: "filled",
                          class: "h-min w-[99.3%] mb-0.5 bg-[#fcfcca]"
                        }, null, 8, ["modelValue", "options"]),
                        _createVNode(Table, {
                          data: { ...state.value.currentPlayState.selectedBowler2data },
                          columns: scoreTwoColumns,
                          class: "scoringTable min-w-min"
                        }, null, 8, ["data"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            (state.value.InningsData[state.value.currentPlayState.inningsIndex] != undefined && Object.keys(state.value.InningsData[state.value.currentPlayState.inningsIndex]).length != 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Bowl End "))
              : _createCommentVNode("", true),
            (state.value.InningsData[state.value.currentPlayState.inningsIndex] != undefined && Object.keys(state.value.InningsData[state.value.currentPlayState.inningsIndex]).length != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: state.value.currentPlayState.delivery.bowlingEnd,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.value.currentPlayState.delivery.bowlingEnd) = $event)),
                    options: bowlingEnd.value,
                    allowEmpty: false,
                    class: "bowling-end w-36 uppercase"
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(Toast)),
            (state.value.currentPlayState.isblurred && (state.value.InningsData[state.value.currentPlayState.inningsIndex] == undefined || state.value.InningsData[state.value.currentPlayState.inningsIndex].battingTeam == undefined))
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_unref(Toast)),
                  _createElementVNode("button", {
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 m-1 flex-1 col-span-1",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(stateStore).addInnings(state.value.MatchInfo.id, state.value.currentPlayState.delivery.innings)))
                  }, " Initialise New Innings ")
                ]))
              : _createCommentVNode("", true),
            (state.value.currentPlayState.isblurred && state.value.InningsData[state.value.currentPlayState.inningsIndex] != undefined && state.value.InningsData[state.value.currentPlayState.inningsIndex].previousDeliveries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createVNode(_unref(Toast)),
                  _createElementVNode("button", {
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 m-1 flex-1 col-span-1",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (confirmNewOver()))
                  }, " Confirm ")
                ]))
              : _createCommentVNode("", true),
            (!state.value.currentPlayState.isblurred)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("button", {
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 m-1 flex-1 col-span-1",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmUpdatePlayers()))
                  }, " Update ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        style: {"height":"100%"},
        class: _normalizeClass(["pt-1", state.value.currentPlayState.delivery.ball <= 1 && state.value.currentPlayState.isblurred ? 'blur' : ''])
      }, [
        _createVNode(DataTabs, {
          headers: smallScreen.value ? wagonWheel : wagonWheel,
          parentTabActive: 0,
          class: "h-full cardsTab"
        }, {
          default: _withCtx((slotProps) => [
            (slotProps.index == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_unref(ConfirmDialog), { group: "headless" }, {
                            container: _withCtx(({ message, acceptCallback, rejectCallback }) => [
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("span", _hoisted_63, _toDisplayString(message.header), 1),
                                _createElementVNode("p", _hoisted_64, _toDisplayString(message.message), 1),
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_unref(Button), {
                                    label: "Deny",
                                    outlined: "",
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 hover:bg-gray-400 hover:border-gray-400 mr-2",
                                    onClick: rejectCallback
                                  }, null, 8, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    label: "Confirm",
                                    onClick: acceptCallback,
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 bg-[#ced4db] hover:bg-gray-400 hover:border-gray-400"
                                  }, null, 8, ["onClick"])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(ConfirmDialog), { group: "headless2" }, {
                            container: _withCtx(({ message, acceptCallback, rejectCallback }) => [
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createElementVNode("span", _hoisted_68, _toDisplayString(message.header), 1),
                                _createElementVNode("p", _hoisted_69, _toDisplayString(message.message), 1),
                                _createTextVNode(" IS DECLARED: "),
                                _createVNode(_unref(ToggleButton), {
                                  modelValue: _unref(isDeclare),
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(isDeclare) ? (isDeclare).value = $event : isDeclare = $event)),
                                  invalid: "",
                                  class: "w-5rem mt-2 finishMatch",
                                  "pt:label:class": "!border-none !py-0 !px-3",
                                  "aria-label": "Confirmation"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_70, [
                                  _createVNode(_unref(Button), {
                                    label: "Cancel",
                                    outlined: "",
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 hover:bg-gray-400 hover:border-gray-400 mr-2",
                                    onClick: rejectCallback
                                  }, null, 8, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    label: "Confirm",
                                    onClick: acceptCallback,
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 bg-[#ced4db] hover:bg-gray-400 hover:border-gray-400"
                                  }, null, 8, ["onClick"])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(ConfirmDialog), { group: "headlessMatch" }, {
                            container: _withCtx(({ message, acceptCallback, rejectCallback }) => [
                              _createElementVNode("div", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("span", _hoisted_73, _toDisplayString(message.header), 1),
                                _createElementVNode("p", _hoisted_74, _toDisplayString(message.message), 1),
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_unref(SelectButton), {
                                    modelValue: matchResultValue.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((matchResultValue).value = $event)),
                                    allowEmpty: false,
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (teamSelectedResult.value.value = '')),
                                    class: "finishMatch",
                                    options: getResultOptions(),
                                    "option-label": "value"
                                  }, {
                                    option: _withCtx((slotProps) => [
                                      _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("p", _hoisted_77, _toDisplayString(slotProps.option.label), 1),
                                        _createElementVNode("p", _hoisted_78, _toDisplayString(slotProps.option.description), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "options"])
                                ]),
                                _createVNode(_unref(Inplace), {
                                  "pt:display:class": "flex",
                                  "pt:content:class": "flex flex-col items-center"
                                }, {
                                  display: _withCtx(() => [
                                    _hoisted_79
                                  ]),
                                  content: _withCtx(() => [
                                    _hoisted_80,
                                    _createElementVNode("div", _hoisted_81, [
                                      _createElementVNode("div", _hoisted_82, [
                                        _createVNode(_unref(SelectButton), {
                                          modelValue: teamSelectedResult.value,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((teamSelectedResult).value = $event)),
                                          class: "flex flex-col justify-center finishMatch mr-4 w-fit",
                                          allowEmpty: false,
                                          "option-label": "value",
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => (matchResultValue.value.value = '')),
                                          "pt:label:class": "!border-none",
                                          options: getResultOptionsTeams()
                                        }, {
                                          option: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_83, [
                                              _createElementVNode("p", _hoisted_84, _toDisplayString(slotProps.option.value), 1),
                                              _createElementVNode("p", _hoisted_85, _toDisplayString(slotProps.option.description), 1)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "options"])
                                      ]),
                                      _createElementVNode("div", _hoisted_86, [
                                        _createVNode(_unref(SelectButton), {
                                          modelValue: matchResultValue.value,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((matchResultValue).value = $event)),
                                          allowEmpty: false,
                                          "pt:button:class": "p-0",
                                          disabled: teamSelectedResult.value.value == '',
                                          "pt:label:class": "!border-none",
                                          class: "flex flex-col finishMatch self-center ml-3 w-fit",
                                          "option-label": "value",
                                          options: getOtherResultOptions(true)
                                        }, null, 8, ["modelValue", "disabled", "options"])
                                      ])
                                    ]),
                                    _hoisted_87,
                                    _createVNode(_unref(SelectButton), {
                                      modelValue: matchResultValue.value,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((matchResultValue).value = $event)),
                                      allowEmpty: false,
                                      "pt:label:class": "!border-none",
                                      "option-label": "value",
                                      "pt:button:class": "p-0",
                                      onChange: _cache[18] || (_cache[18] = ($event: any) => (teamSelectedResult.value.value = '')),
                                      class: "finishMatch",
                                      options: getOtherResultOptions(false)
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", _hoisted_88, [
                                  _createVNode(_unref(Button), {
                                    label: "CANCEL",
                                    outlined: "",
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 hover:bg-gray-400 hover:border-gray-400 mr-2",
                                    onClick: rejectCallback
                                  }, null, 8, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    label: 'CONFIRM ' + teamSelectedResult.value.value + ' ' + matchResultValue.value.value,
                                    onClick: acceptCallback,
                                    "pt:label:class": "!m-0 !border-none",
                                    class: "outline-none border-[#ced4db] border-2 bg-[#ced4db] hover:bg-gray-400 hover:border-gray-400",
                                    disabled: matchResultValue.value.value == ''
                                  }, null, 8, ["label", "onClick", "disabled"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("button", {
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (requireConfirmationMatch())),
                            class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 flex-1 col-span-1 uppercase"
                          }, " Finish Match "),
                          _createElementVNode("button", {
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (requireConfirmationInnings())),
                            class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 flex-1 col-span-1 uppercase"
                          }, " Finish Inning ")
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  (!state.value.currentPlayState.isblurred)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.InningsData[state.value.currentPlayState.inningsIndex].extras, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "h-full w-full content-center justify-center",
                              style: {"flex-direction":"column","align-items":"center","align-self":"center","display":"flex"},
                              key: index
                            }, [
                              _createElementVNode("div", null, _toDisplayString(index), 1),
                              _createElementVNode("div", _hoisted_93, _toDisplayString(item), 1)
                            ]))
                          }), 128))
                        ]),
                        (state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0] != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                              _hoisted_95,
                              _createElementVNode("div", _hoisted_96, [
                                _hoisted_97,
                                _createElementVNode("div", _hoisted_98, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].runs), 1)
                              ]),
                              _createElementVNode("div", _hoisted_99, [
                                _hoisted_100,
                                _createElementVNode("div", _hoisted_101, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].runs), 1)
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[0].player.name), 1),
                                _hoisted_104,
                                _createElementVNode("div", _hoisted_105, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[0].runs) + " / " + _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[0].balls), 1)
                              ]),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[1].player.name), 1),
                                _hoisted_108,
                                _createElementVNode("div", _hoisted_109, _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[1].runs) + " / " + _toDisplayString(state.value.InningsData[state.value.currentPlayState.inningsIndex].partnerships.slice(-1)[0].batsmen[1].balls), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_110, [
                          _hoisted_111,
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, _toDisplayString(state.value.BattingTeam.team.name), 1),
                            (state.value.currentPlayState.reviews)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(state.value.BattingTeam.homeTeam ? state.value.currentPlayState.reviews.maxReviews -
                                            state.value.currentPlayState.reviews.homeReviews.filter(item => item.result=="LOST").length :
                                            state.value.currentPlayState.reviews.maxReviews -
                                            state.value.currentPlayState.reviews.awayReviews.filter(item => item.result=="LOST").length), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_115, "-"))
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, _toDisplayString(state.value.BowlingTeam.team.name), 1),
                            (state.value.currentPlayState.reviews)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(state.value.BowlingTeam.homeTeam ? state.value.currentPlayState.reviews.maxReviews -
                                                state.value.currentPlayState.reviews.homeReviews.filter(item => item.result=="LOST").length :
                                                state.value.currentPlayState.reviews.maxReviews -
                                                state.value.currentPlayState.reviews.awayReviews.filter(item => item.result=="LOST").length), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_119, "-"))
                          ]),
                          (state.value.MatchInfo.matchType == v.MatchTypeEnum.Test)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_120, "DLS "))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex justify-around min-w-fit", _unref(dlsActive) ? 'mr-8' : ''])
                            }, _hoisted_124, 2),
                            _createVNode(_unref(Inplace), {
                              closable: true,
                              onClose: _cache[23] || (_cache[23] = ($event: any) => {dlsInput(); _isRef(dlsActive) //@ts-ignore
 ? dlsActive.value = false : dlsActive = false}),
                              active: _unref(dlsActive),
                              onOpen: _cache[24] || (_cache[24] = ($event: any) => (_isRef(dlsActive) //@ts-ignore
 ? dlsActive.value = true : dlsActive = true)),
                              "pt:display:class": "flex p-0 shadow-none outline-none hover:bg-[#1f2937] hover:text-white",
                              "pt:root:class": "text-center shadow-none outline-none mt-2 mx-0 mb-0",
                              "pt:content:class": "flex",
                              "close-icon": "pi pi-check text-inherit"
                            }, {
                              display: _withCtx(() => [
                                _createElementVNode("div", _hoisted_125, [
                                  _createElementVNode("p", _hoisted_126, _toDisplayString(state.value.currentPlayState.targetScore || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_127, [
                                  _createElementVNode("p", _hoisted_128, _toDisplayString(state.value.currentPlayState.targetOvers || '-'), 1)
                                ])
                              ]),
                              content: _withCtx(() => [
                                _createVNode(_unref(InputNumber), {
                                  modelValue: state.value.currentPlayState.targetScore,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((state.value.currentPlayState.targetScore) = $event)),
                                  autofocus: "",
                                  maxFractionDigits: 0,
                                  min: 0,
                                  max: 999,
                                  mode: "decimal",
                                  class: "text-black *:w-28 mx-2 my-1.5"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_unref(InputNumber), {
                                  modelValue: state.value.currentPlayState.targetOvers,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((state.value.currentPlayState.targetOvers) = $event)),
                                  autofocus: "",
                                  maxFractionDigits: 0,
                                  min: 0,
                                  max: 99,
                                  mode: "decimal",
                                  class: "text-black *:w-28 mx-2 my-1.5"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["active"]),
                            _createElementVNode("div", _hoisted_129, [
                              (!_unref(dlsActive))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 m-1 text-black w-1/4 min-w-fit",
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_isRef(dlsActive) //@ts-ignore
 ? dlsActive.value = !_unref(dlsActive) : dlsActive = !_unref(dlsActive)))
                                  }, " Update "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        }, 8, ["headers"])
      ], 2)
    ]),
    _createElementVNode("div", {
      style: {"scrollbar-width":"thin"},
      class: _normalizeClass(["col-span-4 text-[#dcdde0] flex flex-col", state.value.currentPlayState.delivery.ball <= 1 && state.value.currentPlayState.isblurred ? 'blur' : ''])
    }, [
      _createVNode(DataTabs, {
        headers: smallScreen.value ? scoringHeaders : scoringHeaders,
        parentTabActive: 0,
        class: "h-full scoringTab"
      }, {
        default: _withCtx((slotProps) => [
          (slotProps.index == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((extraLabelsItems.value), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "runs w-full rounded-lg h-full",
                              key: index
                            }, [
                              _createVNode(_unref(Button), {
                                onClick: ($event: any) => (toggleClass(ShotSelection, item, 'extras')),
                                style: _normalizeStyle(state.value.currentPlayState.delivery[item.replace(/\s+/g, '').toLowerCase()] != 0 ? { 'background-color': '#dbb380' } : {}),
                                class: _normalizeClass(state.value.currentPlayState.extras == item || (Number.isInteger(item) && item == state.value.currentPlayState.extrasRuns) ? 'runs2' : 'runs'),
                                label: item,
                                size: "large"
                              }, null, 8, ["onClick", "style", "class", "label"])
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((extrasButtons.value), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "runs w-full rounded-lg h-full ml-0.5",
                              key: index
                            }, [
                              _createVNode(_unref(Button), {
                                onClick: ($event: any) => (toggleClass(ShotSelection, item, 'toggleExtra')),
                                style: _normalizeStyle(state.value.currentPlayState.delivery[item.replace(/\s+/g, '').toLowerCase()] != 0 ? { 'background-color': '#a6ca63' } : {}),
                                class: _normalizeClass(state.value.currentPlayState.shotSelectionText == item ? 'selected' : 'runs'),
                                label: item +' +1',
                                size: "large"
                              }, null, 8, ["onClick", "style", "class", "label"])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_137, [
                          _createVNode(_unref(Button), {
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (state.value.currentPlayState.delivery.dismissal.push({ batsman: { id: state.value.BattingTeam.players.find(u => u.player.id === state.value.currentPlayState.delivery.striker.id).player.id, name: state.value.BattingTeam.players.find(u => u.player.id === state.value.currentPlayState.delivery.striker.id).player.name }, bowler: { id: state.value.BowlingTeam.players.find(u => u.player.id === state.value.currentPlayState.delivery.bowler.id).player.id, name: state.value.BowlingTeam.players.find(u => u.player.id === state.value.currentPlayState.delivery.bowler.id).player.name }, dismissalCode: v.DismissalCodeEnum.CAUGHT, attributableToBowler: true }))),
                            label: "DISMISSAL",
                            size: "large"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("div", _hoisted_139, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runItems.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "runs w-full rounded-lg h-full",
                              key: index
                            }, [
                              _createVNode(_unref(Button), {
                                onClick: ($event: any) => (toggleClass(ShotSelection, item, 'runSelect')),
                                label: item,
                                size: "large",
                                class: _normalizeClass([state.value.currentPlayState.delivery[state.value.currentPlayState.extras.replace(/\s+/g, '').toLowerCase()] == Number.parseInt(item, 10) ? 'runs2' : 'runs', state.value.currentPlayState.delivery[state.value.currentPlayState.extras.replace(/\s+/g, '').toLowerCase()] == Number.parseInt(item, 10) && state.value.currentPlayState.delivery.wides > 0 ? '!bg-[#a6ca63]': '' ])
                              }, null, 8, ["onClick", "label", "class"])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_140, [
                            _createVNode(_unref(Button), {
                              onClick: toggle,
                              label: "+",
                              size: "large",
                              class: _normalizeClass('runs')
                            })
                          ]),
                          _createVNode(_unref(OverlayPanel), {
                            ref_key: "op",
                            ref: op,
                            style: {"background-color":"#d4e6ff !important"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("label", _hoisted_142, _toDisplayString(state.value.currentPlayState.extras) + " Total ", 1),
                                _createVNode(_unref(InputNumber), {
                                  modelValue: state.value.currentPlayState.delivery[state.value.currentPlayState.extras.replace(/\s+/g, '').toLowerCase()],
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((state.value.currentPlayState.delivery[state.value.currentPlayState.extras.replace(/\s+/g, '').toLowerCase()]) = $event)),
                                  showButtons: "",
                                  buttonLayout: "horizontal",
                                  style: {"width":"3rem","background-color":"#d4e6ff !important"},
                                  min: 0,
                                  max: 20
                                }, {
                                  incrementbuttonicon: _withCtx(() => [
                                    _hoisted_143
                                  ]),
                                  decrementbuttonicon: _withCtx(() => [
                                    _hoisted_144
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _createElementVNode("div", _hoisted_145, [
                          _hoisted_146,
                          _createElementVNode("div", _hoisted_147, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boundary.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "runs w-full rounded-lg h-full",
                                key: index
                              }, [
                                _createVNode(_unref(Button), {
                                  onClick: ($event: any) => (toggleClass(ShotSelection, item, 'boundary')),
                                  label: item,
                                  size: "large",
                                  class: _normalizeClass(state.value.currentPlayState.delivery.boundary == Number.parseInt(item) ? 'runs2' : 'runs')
                                }, null, 8, ["onClick", "label", "class"])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      (state.value.currentPlayState.delivery.dismissal.length != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((state.value.currentPlayState.delivery.dismissal), (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "flex w-full h-full justify-between mt-2 items-center !bg-[#94a3b8]",
                                style: {"background":"lightslategray","border-radius":"5px 5px 5px 5px"}
                              }, [
                                _createElementVNode("div", _hoisted_149, [
                                  _createVNode(_unref(Dropdown), {
                                    "pt:input:class": "pr-0",
                                    modelValue: state.value.currentPlayState.delivery.dismissal[index].dismissalCode,
                                    "onUpdate:modelValue": ($event: any) => ((state.value.currentPlayState.delivery.dismissal[index].dismissalCode) = $event),
                                    options: dismissal,
                                    optionLabel: "name",
                                    optionValue: "code",
                                    variant: "filled",
                                    class: "h-min m-1"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_150, [
                                  _hoisted_151,
                                  _createVNode(_unref(Dropdown), {
                                    modelValue: state.value.currentPlayState.delivery.dismissal[index].batsman,
                                    "onUpdate:modelValue": ($event: any) => ((state.value.currentPlayState.delivery.dismissal[index].batsman) = $event),
                                    options: convertOptions(state.value.BattingTeam.players),
                                    optionLabel: "name",
                                    variant: "filled",
                                    class: "h-min ml-2 m-1",
                                    "pt:input:class": "pr-0"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_152, [
                                  _hoisted_153,
                                  _createVNode(_unref(Dropdown), {
                                    modelValue: state.value.currentPlayState.delivery.dismissal[index].bowler,
                                    "onUpdate:modelValue": ($event: any) => ((state.value.currentPlayState.delivery.dismissal[index].bowler) = $event),
                                    options: convertOptions(state.value.BowlingTeam.players),
                                    optionLabel: "name",
                                    variant: "filled",
                                    class: "h-min ml-2 m-1",
                                    "pt:input:class": "pr-0"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_154, [
                                  _hoisted_155,
                                  _createVNode(_unref(Dropdown), {
                                    modelValue: state.value.currentPlayState.delivery.dismissal[index].fielder,
                                    "onUpdate:modelValue": ($event: any) => ((state.value.currentPlayState.delivery.dismissal[index].fielder) = $event),
                                    options: convertOptions(state.value.BowlingTeam.players),
                                    optionLabel: "name",
                                    variant: "filled",
                                    class: "h-min ml-2 m-1",
                                    "pt:input:class": "pr-0"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_156, [
                                  _hoisted_157,
                                  _createVNode(_unref(Checkbox), {
                                    class: "ml-2",
                                    "pt:box:class": "border-none !bg-white",
                                    "pt:icon:class": "text-black",
                                    modelValue: state.value.currentPlayState.delivery.dismissal[index].attributableToBowler,
                                    "onUpdate:modelValue": ($event: any) => ((state.value.currentPlayState.delivery.dismissal[index].attributableToBowler) = $event),
                                    binary: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", {
                                    class: "pi pi-trash pr-4 mt-1",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => { state.value.currentPlayState.delivery.dismissal.splice(index, 1);}
                                  }, null, 8, _hoisted_158)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    _hoisted_160,
                    _createElementVNode("div", _hoisted_161, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shotIntention, (item, index) => {
                        return _createElementVNode("div", {
                          class: "shot-intention rounded-lg h-full",
                          key: index
                        }, [
                          _createVNode(_unref(Button), {
                            onClick: ($event: any) => (toggleClass(ShotSelection, item, 'shotSelection')),
                            class: _normalizeClass(state.value.currentPlayState.shotSelectionText == item ? 'shot2' : 'shot-intention'),
                            label: item,
                            size: "large"
                          }, null, 8, ["onClick", "class", "label"])
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_162, [
                    _hoisted_163,
                    _createElementVNode("div", _hoisted_164, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(batting, (item, index) => {
                        return _createElementVNode("div", {
                          class: "batting rounded-lg h-full",
                          key: index
                        }, [
                          _createVNode(_unref(Button), {
                            onClick: ($event: any) => (toggleClass(Dismissal, item, 'batting')),
                            class: _normalizeClass(state.value.currentPlayState.battingSelection.indexOf(item) > -1 ? 'batt2' : 'batting'),
                            label: item,
                            size: "large"
                          }, null, 8, ["onClick", "class", "label"])
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _hoisted_166,
                    _createElementVNode("div", _hoisted_167, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bowling, (item, index) => {
                        return _createElementVNode("div", {
                          class: "bowling rounded-lg h-full",
                          key: index
                        }, [
                          _createVNode(_unref(Button), {
                            onClick: ($event: any) => (toggleClass(DeliveryType, item, 'bowlingSelection')),
                            class: _normalizeClass(state.value.currentPlayState.bowlSelectionText == item ? 'bowl2' : 'bowling'),
                            label: item,
                            size: "large"
                          }, null, 8, ["onClick", "class", "label"])
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _hoisted_169,
                    _createElementVNode("div", _hoisted_170, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fielding, (item, index) => {
                        return _createElementVNode("div", {
                          class: "fielding rounded-lg h-full",
                          key: index
                        }, [
                          _createVNode(_unref(Button), {
                            onClick: ($event: any) => (toggleClass(Dismissal, item, 'fielding')),
                            class: _normalizeClass(state.value.currentPlayState.fieldingSelection.indexOf(item) > -1 ? 'field2' : 'fielding'),
                            label: item,
                            size: "large"
                          }, null, 8, ["onClick", "class", "label"])
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _hoisted_172,
                    _createElementVNode("div", _hoisted_173, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(event, (item, index) => {
                        return _createElementVNode("div", {
                          class: "batting1 rounded-lg h-full",
                          key: index
                        }, [
                          (item == 'Drs Challenge' || item.includes('appeal'))
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 0,
                                onClick: _cache[28] || (_cache[28] = ($event: any) => ( beginReview())),
                                disabled: visible.value,
                                class: _normalizeClass(state.value.currentPlayState.battingSelection.indexOf(item) > -1 ? 'batt3' : 'batting1'),
                                label: item,
                                size: "large"
                              }, null, 8, ["disabled", "class", "label"]))
                            : (_openBlock(), _createBlock(_unref(Button), {
                                key: 1,
                                onClick: ($event: any) => (toggleClass(Dismissal, item, 'batting')),
                                class: _normalizeClass(state.value.currentPlayState.battingSelection.indexOf(item) > -1 ? 'batt3' : 'batting1'),
                                label: item,
                                size: "large"
                              }, null, 8, ["onClick", "class", "label"]))
                        ])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _hoisted_175,
                    _createElementVNode("div", _hoisted_176, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(breaksInPlay, (item, index) => {
                        return _createElementVNode("div", {
                          class: "breaks-in-play rounded-lg h-full",
                          key: index
                        }, [
                          _createVNode(_unref(Button), {
                            onClick: ($event: any) => (toggleClass(Dismissal, item, 'breaks')),
                            class: _normalizeClass(state.value.currentPlayState.delivery.breaks?.indexOf(item) > -1 ? 'breaks2' : 'breaks-in-play'),
                            label: item.substr(0, item.lastIndexOf('_')).replace(/_/g, ' '),
                            size: "large"
                          }, null, 8, ["onClick", "class", "label"])
                        ])
                      }), 64))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("button", {
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (requireConfirmationOver())),
                      class: "bg-[#ced4db] hover:bg-slate-500 text-black font-semi rounded px-2 md:py-2 py-1 m-1 uppercase w-full"
                    }, " Finish Over ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["headers"])
    ], 2),
    _createElementVNode("div", {
      style: {"scrollbar-width":"thin"},
      class: _normalizeClass(["col-span-3 md:mt-0 mt-2", state.value.currentPlayState.delivery.ball <= 1 && state.value.currentPlayState.isblurred ? 'blur' : ''])
    }, [
      _createVNode(DataTabs, {
        headers: smallScreen.value ? cardHeadersShort : cardHeaders,
        parentTabActive: 0,
        class: "h-full cardsTab",
        tabIndex: 1
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_179, [
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("div", _hoisted_181, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.InningsData, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "innsel rounded-lg h-full",
                    key: index
                  }, [
                    (item.number != undefined)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          onClick: ($event: any) => (selectInnings(item)),
                          class: _normalizeClass(item.number == state.value.currentPlayState.inningsIndex + 1 ? 'innsel2' : 'innsel'),
                          label: item.number + ' : ' + item.score + ' - ' +
                                        item.wickets
                                        ,
                          size: "large"
                        }, null, 8, ["onClick", "class", "label"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_182,
            (state.value.InningsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                  _createVNode(_unref(DataTable), {
                    scrollable: "",
                    scrollHeight: "flex",
                    rowClass: _ctx.rowClass,
                    reorderableColumns: true,
                    selection: state.value.currentPlayState.selectedBall,
                    "onUpdate:selection": _cache[30] || (_cache[30] = ($event: any) => ((state.value.currentPlayState.selectedBall) = $event)),
                    resizableColumns: "",
                    columnResizeMode: "expand",
                    value: state.value.InningsData[state.value.currentPlayState.inningsIndex].previousDeliveries,
                    stripedRows: "",
                    size: "small",
                    selectionMode: editMode.value ? undefined : 'single',
                    onRowSelect: onRowSelect,
                    rowStyle: rowStyle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" > "),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ballByBallColumns, (col) => {
                        return _createVNode(_unref(Column), {
                          headerStyle: "background-color: #cccccc",
                          key: col.key,
                          field: col.key,
                          header: col.name
                        }, null, 8, ["field", "header"])
                      }), 64)),
                      _createVNode(_unref(Column), {
                        headerStyle: "background-color: #cccccc",
                        field: "dismissal",
                        header: "WKT"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_184, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.dismissal, (i) => {
                              return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(i.dismissalCode), 1))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        headerStyle: "background-color: #cccccc",
                        field: "penfor",
                        header: "P"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_185, [
                            (slotProps.data.penfor > 0 || slotProps.data.penagainst > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_186, _hoisted_188))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        headerStyle: "background-color: #cccccc",
                        field: "reviewAway",
                        header: "R-A"
                      }, {
                        body: _withCtx((slotProps) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.currentPlayState.reviews.awayReviews, (i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex items-center gap-2",
                              key: i
                            }, [
                              (slotProps.data.ball == i.ball && slotProps.data.number == i.delivery && slotProps.data.innings == i.innings && slotProps.data.over == i.over)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_189, _hoisted_191))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        headerStyle: "background-color: #cccccc",
                        field: "reviewHome",
                        header: "R-H"
                      }, {
                        body: _withCtx((slotProps) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.currentPlayState.reviews.homeReviews, (i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex items-center gap-2",
                              key: i
                            }, [
                              (slotProps.data.ball == i.ball && slotProps.data.number == i.delivery && slotProps.data.innings == i.innings && slotProps.data.over == i.over)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_192, _hoisted_194))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["rowClass", "selection", "value", "selectionMode"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "flex justify-between h-min 2xl:text-base xl:text-sm text-xs text-black",
              onMouseout: _cache[31] || (_cache[31] = ($event: any) => (_isRef(disabledSubmit) //@ts-ignore
 ? disabledSubmit.value = false : disabledSubmit = false))
            }, [
              (!editMode.value && state.value.currentPlayState.selectedBall)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: editSelectedBall,
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 col-span-2 w-full"
                  }, " EDIT SELECTED "))
                : _createCommentVNode("", true),
              (!editMode.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: saveCurrentState,
                    disabled: _unref(disabledSubmit),
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 col-span-2 w-full"
                  }, " SAVE AND CREATE ", 8, _hoisted_195))
                : _createCommentVNode("", true),
              (editMode.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: abortEdit,
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 col-span-2 w-full"
                  }, " ABORT EDITING "))
                : _createCommentVNode("", true),
              (editMode.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: saveCurrentState,
                    class: "bg-[#ced4db] hover:bg-slate-500 font-semi rounded px-2 md:py-2 py-1 m-1 col-span-2 w-full"
                  }, " SAVE AND RETURN "))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ]),
        _: 1
      }, 8, ["headers"])
    ], 2),
    _createVNode(_unref(Dialog), {
      visible: visible.value,
      "onUpdate:visible": [
        _cache[37] || (_cache[37] = ($event: any) => ((visible).value = $event)),
        _cache[38] || (_cache[38] = ($event: any) => ( cancelReview()))
      ],
      header: "Active Review",
      style: { width: '30rem' },
      "pt:title:class": "w-full text-center",
      "pt:header:class": "pb-1",
      closable: !teamHasBeenSelected.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_196, [
          _createElementVNode("li", _hoisted_197, [
            _hoisted_198,
            _createTextVNode(" " + _toDisplayString(_unref(reviewObject).innings) + " ", 1),
            _hoisted_199,
            _createTextVNode(" " + _toDisplayString(_unref(reviewObject).over) + " ", 1),
            _hoisted_200,
            _createTextVNode(" " + _toDisplayString(_unref(reviewObject).ball) + " ", 1),
            _hoisted_201,
            _createTextVNode(" " + _toDisplayString(_unref(reviewObject).delivery), 1)
          ])
        ]),
        (!teamHasBeenSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
              _createElementVNode("div", _hoisted_203, [
                _hoisted_204,
                _createElementVNode("div", _hoisted_205, [
                  _createElementVNode("div", _hoisted_206, [
                    _createVNode(_unref(SelectButton), {
                      modelValue: _unref(reviewObject).selectedTeam,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(reviewObject).selectedTeam) = $event)),
                      options: [state.value.BattingTeam.team, state.value.BowlingTeam.team],
                      optionLabel: "name",
                      disabled: false,
                      pt: { button: { class: ['py-6 px-6 bg-[#e5e7eb] border rounded-md m-1 w-[175px] text-base hover:bg-[#e0cafc]'] }, },
                      class: "toss-decision bg-[#e5e7eb] rounded-md review"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_207, [
                _createVNode(_unref(Button), {
                  class: "outline-none border-[#ced4db] border-2 hover:bg-[#ced4db] w-1/3 p-1 mr-2",
                  type: "button",
                  label: "CANCEL",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => {cancelReview();})
                }),
                _createVNode(_unref(Button), {
                  class: "outline-none bg-[#ced4db] hover:bg-slate-500 w-1/3 p-1",
                  type: "button",
                  label: "CREATE",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => {teamHasBeenSelected.value = true; pendingReview();}),
                  disabled: _unref(reviewObject).selectedTeam == null,
                  autofocus: ""
                }, null, 8, ["disabled"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_208, [
              _createElementVNode("p", _hoisted_209, _toDisplayString(_unref(reviewObject).selectedTeam.name), 1),
              _createElementVNode("div", _hoisted_210, [
                _hoisted_211,
                _createElementVNode("div", _hoisted_212, [
                  _createElementVNode("div", _hoisted_213, [
                    _createVNode(_unref(SelectButton), {
                      modelValue: _unref(reviewObject).result,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(reviewObject).result) = $event)),
                      options: ['Retained', 'Lost'],
                      disabled: _unref(reviewObject).selectedTeam == null,
                      pt: { button: { class: ['py-6 px-6 bg-[#e5e7eb] border rounded-md m-1 w-[175px] text-base hover:bg-[#e0cafc]'] }, },
                      class: "toss-decision bg-[#e5e7eb] rounded-md review"
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_214, [
                _createVNode(_unref(Button), {
                  class: "outline-none w-1/3 p-1 bg-[#ced4db] hover:bg-slate-500",
                  type: "button",
                  label: "SUBMIT",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => {visible.value = false; submitReview();}),
                  disabled: _unref(reviewObject).result == null,
                  autofocus: ""
                }, null, 8, ["disabled"])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["visible", "closable"]),
    _createVNode(_unref(Dialog), {
      visible: newInnings.value,
      "onUpdate:visible": _cache[44] || (_cache[44] = ($event: any) => ((newInnings).value = $event)),
      modal: "",
      header: "Manual Innings Override",
      "pt:footer:class": "justify-center"
    }, {
      header: _withCtx(() => [
        _hoisted_215
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          type: "button",
          label: "Create Play",
          class: "outline-none shadow-none border-[#ced4db] border-2 hover:bg-[#ced4db] mr-2 py-1.5 px-2",
          onClick: _cache[43] || (_cache[43] = ($event: any) => (manualOverrideTriggered())),
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_216, [
          _createElementVNode("div", _hoisted_217, [
            _hoisted_218,
            _createVNode(_unref(InputNumber), {
              modelValue: _unref(manualoverride).manualinnings,
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(manualoverride).manualinnings) = $event)),
              showButtons: "",
              buttonLayout: "vertical",
              "pt:input:class": "border-y border-[#ced4db]",
              style: {"width":"3rem"},
              min: 1,
              max: 10,
              class: "blueNumberInput m-2 rounded-md border border-[#ced4db]"
            }, {
              incrementbuttonicon: _withCtx(() => [
                _hoisted_219
              ]),
              decrementbuttonicon: _withCtx(() => [
                _hoisted_220
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_221, [
            _hoisted_222,
            _createVNode(_unref(InputNumber), {
              modelValue: _unref(manualoverride).manualover,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(manualoverride).manualover) = $event)),
              showButtons: "",
              buttonLayout: "vertical",
              "pt:input:class": "border-y border-[#ced4db]",
              style: {"width":"3rem"},
              min: 0,
              max: 70,
              class: "blueNumberInput m-2 rounded-md border border-[#ced4db]"
            }, {
              incrementbuttonicon: _withCtx(() => [
                _hoisted_223
              ]),
              decrementbuttonicon: _withCtx(() => [
                _hoisted_224
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_225, [
            _hoisted_226,
            _createVNode(_unref(InputNumber), {
              modelValue: _unref(manualoverride).manualball,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(manualoverride).manualball) = $event)),
              showButtons: "",
              buttonLayout: "vertical",
              "pt:input:class": "border-y border-[#ced4db]",
              style: {"width":"3rem"},
              min: 1,
              max: 40,
              class: "blueNumberInput m-2 rounded-md border border-[#ced4db]"
            }, {
              incrementbuttonicon: _withCtx(() => [
                _hoisted_227
              ]),
              decrementbuttonicon: _withCtx(() => [
                _hoisted_228
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_229, [
            _hoisted_230,
            _createVNode(_unref(InputNumber), {
              modelValue: _unref(manualoverride).manualdelivery,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(manualoverride).manualdelivery) = $event)),
              showButtons: "",
              buttonLayout: "vertical",
              "pt:input:class": "border-y border-[#ced4db]",
              style: {"width":"3rem"},
              min: 1,
              max: 40,
              class: "blueNumberInput m-2 rounded-md border border-[#ced4db]"
            }, {
              incrementbuttonicon: _withCtx(() => [
                _hoisted_231
              ]),
              decrementbuttonicon: _withCtx(() => [
                _hoisted_232
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})